/* LMM Sticky Header — misst die Header-Teilhoehen fuer lmm-header-sticky.css.
   --lmmh-collapse = Topbar + Trustbar (scrollt hinaus)
   --lmmh-stickyh  = lmmh-main + lmmh-nav (bleibt kleben; mobil ist lmmh-nav
   ausgeblendet und liefert 0). Kein Scroll-Listener — position:sticky macht
   die Arbeit, hier wird nur responsive nachgemessen. */
(function () {
  'use strict';
  if (window.__lmmHeaderStickyInit) return;
  window.__lmmHeaderStickyInit = true;

  var group = document.getElementById('header-group');
  if (!group) return;

  function h(sel) {
    var el = group.querySelector(sel);
    return el ? el.offsetHeight : 0;
  }

  function measure() {
    /* .lmmh-utility = fusionierte REVIEWS-/USP-Zeile des Modern-Header-JS
       (ersetzt lmmh-topbar + lmmh-trustbar nach dem Umbau); im no-JS-Markup
       tragen die Originalklassen — beide addieren deckt beide Welten ab. */
    var collapse = h('.lmmh-topbar') + h('.lmmh-trustbar') + h('.lmmh-utility');
    var stickyh = h('.lmmh-main') + h('.lmmh-nav');
    var root = document.documentElement.style;
    root.setProperty('--lmmh-collapse', collapse + 'px');
    if (stickyh > 0) root.setProperty('--lmmh-stickyh', stickyh + 'px');
  }

  var raf = null;
  function queueMeasure() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = null;
      measure();
    });
  }

  measure();
  window.addEventListener('resize', queueMeasure);
  window.addEventListener('load', queueMeasure);
  /* Header-Hoehe aendert sich auch ohne Resize: Modern-Umbau (lmmh-utility),
     nachladendes REVIEWS-Widget, Font-Swap — alles nachmessen. */
  if ('ResizeObserver' in window) {
    new ResizeObserver(queueMeasure).observe(group);
  }
})();
